export const CANCEL_EVENT = 'cancel';

export const CANCEL_AUTO_CLOSE_EVENT = 'cancel_auto_close';

export const CANCEL_AUTO_CONFIRM_EVENT = 'cancel_auto_confirm';

export const IMG_LOADED_EVENT = 'imgLoaded';

export const CONFIRM_EVENT = 'confirm';

export const CHANGE_EVENT = 'change';

export const CLOSE_EVENT = 'close';

export const REFUND_EVENT = 'refund';

export const LIKE_EVENT = 'like';

export const EDIT_EVENT = 'edit';

export const COMMENT_EVENT = 'comment';

export const REPLIES_EVENT = 'replies';

export const OPEN_BLINDBOX_EVENT = 'openBlindbox';

export const DELETE_EVENT = 'delete';

export const CLICK_EVENT = 'click';

export const CLEAR_EVENT = 'clear';

export const END_EVENT = 'end';

export const CLICK_HOT_ZONE_EVENT = 'clickHotZone';

export const SELECT_EVENT = 'select';

export const SKU_CHANGE_EVENT = 'skuChange';

export const SKU_CLICK_EVENT = 'skuClick';

export const ADD_TO_CART_EVENT = 'addToCart';

export const POPUP_STATE_CHANGE_EVENT = 'popupStateChange';

export const POPUP_STATE_OPEN_EVENT = 'popupStateOpen';

export const COUNT_CHANGE_EVENT = 'countChange';

export const TAB_ITEM_CLICK_EVENT = 'tabItemClick';

export const PAGE_LOADED = 'pageLoaded';

export const EMPTY_EVENT = 'empty';

export const FORUM_POST_UPDATE_EVENT = 'forumPostUpdate';

/** 定时开售倒计时结束事件 */
export const REGULAR_ON_SALES_CD_END_EVENT = 'regularOnSalesCdEnd';
